import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'

const ProductInfoVariationForty = (props) => {
  const styles = useStyles()
  const { t } = props

  return (
    <Box
      style={{
        backgroundImage: `url(${props.imageUrl})`,
      }}
      className={styles.fortyVariantRoot}
    >
      <Box className={props.imageUrl ? styles.fortyVariantSubTypeImage : ''}>
        {props.icon}
        {props.subtitle && (
          <Typography variant="body2">{t(props.subtitle)}</Typography>
        )}
        {props.title && (
          <Typography
            variant="h1"
            className={
              props.imageUrl
                ? styles.fortyVariantTitleForImage
                : styles.fortyVariantTitle
            }
          >
            {t(props.title)}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default ProductInfoVariationForty
